module.exports = __webpack_public_path__ + "img/universkin-M.87a7a167.jpg";